import shop, { getServerSideProps } from './shop';
export default shop;
export { getServerSideProps };
